module.exports = __webpack_public_path__ + "img/mr.033b584a.svg";